import { useState } from 'react';
import { AmazonButton } from 'components/common/AmazonButton';
import { backendHost, backendSsoUrl } from 'utils/constants';
import useDefaultParamsCountry from 'utils/useDefaultParamsCountry';
import { ssoLoginTracking } from 'Marketing/loginTracking';
import { getReturnToParam } from 'utils/getReturnToParam';

export const LoginWithAmazon = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const country = useDefaultParamsCountry();

  const handleClickAmazon = () => {
    setIsButtonDisabled(true);
    ssoLoginTracking(country);
    const returnTo = getReturnToParam();
    const url = returnTo
      ? `${backendHost}${backendSsoUrl}?return_to=${encodeURIComponent(returnTo)}`
      : `${backendHost}${backendSsoUrl}`;
    global.location.assign(url);
  };

  return (
    <AmazonButton
      disabled={isButtonDisabled}
      style={{ width: '100%' }}
      onClick={handleClickAmazon}
      text="Login with Amazon"
    />
  );
};
